import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import HeroSection from '../components/landing/HeroSection';
import ServicesSection from '../components/landing/ServicesSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import TeamSection from '../components/landing/TeamSection';
import ContactSection from '../components/landing/ContactSection';
import ClientsSection from '../components/landing/ClientsSection';
import Footer from '../components/landing/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget';

export default function LandingPage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, [hash]);

  return (
    <div data-testid="landing-page">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <ClientsSection />
      <TestimonialsSection />
      <TeamSection />
      <ContactSection />
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}
